import React, { Component } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./containers/home";
import InstaRecipesPrivacyPolicy from "./containers/instarecipes-privacy-policy";

class App extends Component {
  render() {
    return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/apps/charging-tracker"
          element={
            <Home
              appIds={["charging-tracker"]}
              showIntro={false}
              showAppsHeader={false}
              showThemeButton
              showBackButton
              hideWebsiteLink
              showContactLink
            />
          }
        />
        <Route
          path="/apps/insta-recipes"
          element={
            <Home
              appIds={["instarecipes-reel2meal"]}
              showIntro={false}
              showAppsHeader={false}
              showThemeButton
              showBackButton
              hideWebsiteLink
              showContactLink
            />
          }
        />
        <Route
          path="/apps/capas-do-dia"
          element={
            <Home
              appIds={["capas-do-dia"]}
              showIntro={false}
              showAppsHeader={false}
              showThemeButton
              showBackButton
              hideWebsiteLink
              showContactLink
            />
          }
        />
        <Route
          path="/instarecipes/privacy-policy"
          element={<InstaRecipesPrivacyPolicy />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }
}

export default App;
